import Api from '@silbo/core';

const getLiveQueryURL = (serverURL: string) => {
  const liveQueryURL = new URL(serverURL);
  liveQueryURL.protocol = liveQueryURL.protocol === 'https:' ? 'wss:' : 'ws:';
  return liveQueryURL.toString();
};
/*
  LiveQueryClient is initialized before the React app is loaded.
  Its then defined and available globally without having to use await.
*/
export let liveQueryClient: Parse.LiveQueryClient;

export const initLiveQueryClient = async (serverURL: string, applicationId: string) => {
  // Close the existing live query client if it exists
  if (liveQueryClient) {
    await closeLiveQueryClient(liveQueryClient);
  }

  liveQueryClient = new Api.LiveQueryClient({
    applicationId: applicationId,
    serverURL: getLiveQueryURL(serverURL),
  });

  liveQueryClient.open();
};

const closeLiveQueryClient = async (liveQueryClient: Parse.LiveQueryClient) => {
  // Clear any pending reconnection timeout
  // There is a bug in the Parse SDK where the reconnectHandle is not cleared when the client is closed.
  // And so the client will try to reconnect to the server even after it is closed.
  // https://github.com/parse-community/Parse-SDK-JS/blob/5.3.0/src/LiveQueryClient.ts#L327
  if (liveQueryClient.reconnectHandle) {
    clearTimeout(liveQueryClient.reconnectHandle);
    liveQueryClient.reconnectHandle = null;
  }

  await liveQueryClient.close();
};
